export const convertToDateOrNull = (dateString: string | null): Date | null => {
  return dateString ? new Date(dateString) : null
}
